import { CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';

import { useState } from 'react';

const Notification = () => {
  return (
    <div>
      <Header />
      <EmailNotifications />
    </div>
  );
};

const Header = () => {
  return (
    <div className="px-8 py-6 flex justify-between border-b border-jen-border-primary">
      <CardTitle>Notifications</CardTitle>
    </div>
  );
};

const EmailNotifications = () => {
  const [marketingEmails, setMarketingEmails] = useState(true);
  const [usageLimitAlerts, setUsageLimitAlerts] = useState(false);

  return (
    <div className="p-8 w-[420px] box-content mx-auto">
      <h2 className="text-[20px] text-[#111112] mb-4">Email Notifications</h2>

      <div className="p-4 flex flex-col gap-4 items-center mb-3 rounded-lg border border-jen-border-primary">
        <div className=" flex justify-between w-full">
          <p className="text-[16px] text-jen-content-secondary">Marketing Emails</p>
          <Switch checked={marketingEmails} onCheckedChange={() => setMarketingEmails((prev) => !prev)} />
        </div>
        <p className="text-[14px] text-jen-content-tertiary text-left w-full">
          Receive emails about new products, features and more fun things to do with Jen
        </p>
      </div>
      <div className="p-4 flex flex-col gap-4 items-center mb-3 rounded-lg border border-jen-border-primary">
        <div className=" flex justify-between w-full">
          <p className="text-[16px] text-jen-content-secondary">Usage Limit Alerts</p>
          <Switch checked={usageLimitAlerts} onCheckedChange={() => setUsageLimitAlerts((prev) => !prev)} />
        </div>
        <p className="text-[14px] text-jen-content-tertiary text-left w-full">Receive emails when your usage limit is reached</p>
      </div>
    </div>
  );
};

export default Notification;
